// extracted by mini-css-extract-plugin
module.exports = {"loading":"embed__loading","eyes":"embed__eyes","eye":"embed__eye","one":"embed__one","looking":"embed__looking","two":"embed__two","pulse":"embed__pulse"};